<ng-container>
	<app-ea-spinner *ngIf="!versions"></app-ea-spinner>
	<!--TODO <my-error-component *ngIf="data.error" [error]="data.error"></my-error-component> -->
	<div *ngIf="versions">
		<p-toast></p-toast>

		<h5>{{ "platform.android" | translate }}</h5>
		<div class="formgroup-inline">
			<div class="field">
				<label for="androidminimum" class="p-sr-only"></label>
				<span class="input-help">
					<input
						[disabled]="currentEditedPlatform !== 'ANDROID'"
						id="inputbox"
						type="text"
						pInputText
						[(ngModel)]="versions.android.minimum" />
					<small id="passwordHelpBlock">{{ "version.minimum" | translate }}</small>
				</span>
			</div>
			<div class="field">
				<label for="androidrecommended" class="p-sr-only"></label>
				<span class="input-help">
					<input
						[disabled]="currentEditedPlatform !== 'ANDROID'"
						id="inputbox"
						type="text"
						pInputText
						[(ngModel)]="versions.android.recommended" />
					<small id="passwordHelpBlock">{{ "version.recommended" | translate }}</small>
				</span>
			</div>
			<button
				*ngIf="currentEditedPlatform !== 'ANDROID'"
				pButton
				pRipple
				type="button"
				icon="pi pi-pencil"
				(click)="showVersionDialog('ANDROID')"
				label="{{ 'change.edit' | translate }}"></button>
			<button
				*ngIf="currentEditedPlatform === 'ANDROID'"
				pButton
				pRipple
				type="button"
				icon="pi pi-save"
				(click)="updateVersion()"
				label="{{ 'change.save' | translate }}"></button>
		</div>
		<h5>{{ "platform.ios" | translate }}</h5>
		<div class="formgroup-inline">
			<div class="field">
				<label for="iosminimum" class="p-sr-only"></label>
				<span class="input-help">
					<input
						[disabled]="currentEditedPlatform !== 'IOS'"
						id="inputbox"
						type="text"
						pInputText
						[(ngModel)]="versions.ios.minimum" />
					<small id="passwordHelpBlock">{{ "version.minimum" | translate }}</small>
				</span>
			</div>
			<div class="field">
				<label for="iosrecommended" class="p-sr-only"></label>
				<span class="input-help">
					<input
						[disabled]="currentEditedPlatform !== 'IOS'"
						id="inputbox"
						type="text"
						pInputText
						[(ngModel)]="versions.ios.recommended" />
					<small id="passwordHelpBlock">{{ "version.recommended" | translate }}</small>
				</span>
			</div>
			<button
				*ngIf="currentEditedPlatform !== 'IOS'"
				pButton
				pRipple
				type="button"
				icon="pi pi-pencil"
				(click)="showVersionDialog('IOS')"
				label="{{ 'change.edit' | translate }}"></button>
			<button
				*ngIf="currentEditedPlatform === 'IOS'"
				pButton
				pRipple
				type="button"
				icon="pi pi-save"
				(click)="updateVersion()"
				label="{{ 'change.save' | translate }}"></button>
		</div>
	</div>
</ng-container>
